import _defineProperty from "/var/www/html/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import "core-js/modules/esnext.iterator.constructor.js";
import "core-js/modules/esnext.iterator.filter.js";
import Store from "./Store";
import { getBlockInstance } from "../../../assets/js/mcn-helpers";
import Image from "../library/Image";
import Model from "./Model";
export default class StorePage extends Model {
  constructor(...args) {
    super(...args);
    _defineProperty(this, "id", {
      fieldName: 'id',
      content: null
    });
    _defineProperty(this, "language", {
      fieldName: 'language',
      content: null
    });
    _defineProperty(this, "domain", {
      fieldName: 'domain',
      model: Store,
      content: null
    });
    _defineProperty(this, "type", {
      fieldName: 'type',
      content: null
    });
    _defineProperty(this, "blocks", {
      fieldName: 'blocks',
      dynamicModel: block => getBlockInstance(block === null || block === void 0 ? void 0 : block.type),
      content: null
    });
  }
  getDomain() {
    return this.domain.content;
  }
  getDomainName() {
    let domain = this.getDomain();
    return domain instanceof Store ? domain.getName() : null;
  }
  getDomainLogo() {
    let domain = this.getDomain();
    return domain instanceof Store ? domain.getLogo() : null;
  }
  getDomainLogoUrl() {
    let logo = this.getDomainLogo();
    return logo instanceof Image ? logo.getUrl() : null;
  }
  getLanguage() {
    return this.language.content;
  }
  getType() {
    return this.type.content;
  }
  getUrl() {
    let domainName = this.getDomainName();
    let type = this.getType() !== StorePage.HOME_PAGE ? this.getType() : null;
    return [/^localhost/.test(domainName) ? 'http:/' : 'https:/', domainName, [type, '?lang=', this.getLanguage()].filter(i => i).join('')].join('/');
  }
}
_defineProperty(StorePage, "HOME_PAGE", 'home');
_defineProperty(StorePage, "FAQ_PAGE", 'faq');
_defineProperty(StorePage, "CONTACT_PAGE", 'contact');
_defineProperty(StorePage, "PRODUCT_PAGE", 'product');
_defineProperty(StorePage, "ABOUT_PAGE", 'about');
_defineProperty(StorePage, "SHIPPING_AND_RETURN_PAGE", 'shipping_and_return');
_defineProperty(StorePage, "SERVICE_TERMS_PAGE", 'service_terms');
_defineProperty(StorePage, "PRIVACY_POLICY_PAGE", 'privacy_policy');
_defineProperty(StorePage, "REFUND_POLICY_PAGE", 'refund_policy');
_defineProperty(StorePage, "ARABIC_LANG_SHORT", 'ar');
_defineProperty(StorePage, "ENGLISH_LANG_SHORT", 'en');
_defineProperty(StorePage, "FRENCH_LANG_SHORT", 'fr');
_defineProperty(StorePage, "ITALY_LANG_SHORT", 'it');
_defineProperty(StorePage, "SPANISH_LANG_SHORT", 'es');